// extracted by mini-css-extract-plugin
module.exports = {"Nav":"Header_Nav__1OGkH","logoContainer":"Header_logoContainer__1f3iV","navBar":"Header_navBar__HnHzl","heading1":"Header_heading1__33jqC","heading2":"Header_heading2__cLECf"};